import React, { useContext } from 'react'
import { ErrorMessage } from '../'
import { MedicationRequest, CdsCard, CdsService, CdsDebugInfo, MedicationAdministration } from '../../fhir'
import { Action } from './actions'

export interface StateContext {
  hookInstanceId: string
  medication: any
  medicationRequest: MedicationRequest
  administrations: MedicationAdministration[]
  cards: CdsCard[]
  cdsServices: CdsService[]
  errors: ErrorMessage[]
  serverDebugInfo: CdsDebugInfo[]
  prefetchLoaded: boolean
  servicesLoaded: boolean
  medicationPopulated: boolean
}

export interface Store {
  globalState: StateContext
  dispatch: React.Dispatch<Action>
}

export const defaultState: StateContext = {
  hookInstanceId: '',
  medication: {},
  medicationRequest: {} as MedicationRequest,
  administrations: [],
  cards: [],
  cdsServices: [] as CdsService[],
  errors: [] as ErrorMessage[],
  serverDebugInfo: [] as CdsDebugInfo[],
  prefetchLoaded: false,
  servicesLoaded: false,
  medicationPopulated: false
}

export const AppContext = React.createContext<Store>({
  globalState: defaultState,
  dispatch: () => null,
})

export const useAdministrationStateContext = () => useContext(AppContext)
